// react core
import { useContext } from "react";

// material design
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import Accordion from "@mui/material/Accordion";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// entzy context
import configEntzy from "components/config/ConfigEntzy";
import { EventContext } from "components/event/EventContext";
import { ActionBoxButton } from "components/utils/common/CommonButtons";
// import { ActionLoader } from "components/utils/common/CommonLoaders";
// import { TextTag } from "components/utils/common/CommonTags";

// entzy components
import ActionMessagingSettings from "./ActionMessagingSettings";
import ActionMessagingSelectorDates from "./ActionMessagingSelectorDates";
import { Typography } from "@mui/material";

// fonts and colors
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBell as iconNotifications } from "@fortawesome/pro-duotone-svg-icons";

function ActionMessagingSelector(props) {
  // const user = props.user;
  const eventContext = useContext(EventContext);

  // const notificationsActive =
  //   eventContext.state.messaging.rooms[eventContext.state.messaging.activeRoom]
  //     .settingsHydrated &&
  //   (eventContext.state.messaging.rooms[eventContext.state.messaging.activeRoom]
  //     .settingsData.mail ||
  //     eventContext.state.messaging.rooms[
  //       eventContext.state.messaging.activeRoom
  //     ].settingsData.push);

  // const isAiRoom = eventContext.state.messaging.activeRoom.startsWith("ai");

  const visibleRooms = Object.keys(eventContext.state.messaging.rooms).filter(
    (key) =>
      !key.startsWith("ai") &&
      !(
        (key.includes("runner") && !eventContext.state.event.manager) ||
        (key.includes("rider") && eventContext.state.event.manager)
      ) &&
      !key.includes("|")
  );
  // move front desk to the front
  // const deskIndex = visibleRooms.indexOf("desk");
  // if (deskIndex > -1) {
  //   visibleRooms.splice(deskIndex, 1);
  //   visibleRooms.unshift("desk");
  // }

  return (
    <Box className="box-default">
      <Box className="box-default" sx={{ pt: configEntzy.APP_SPACING_MD }}>
        <Typography variant="subtitle1">
          <em>
            <span>Settings for room</span>
            <span>&nbsp;</span>
            <span>
              {eventContext.state.messaging.activeRoom.replace("|", " | ")}
            </span>
          </em>
        </Typography>
      </Box>
      <Box className="box-default" sx={{ pt: configEntzy.APP_SPACING_MD }}>
        <ActionMessagingSettings
          {...props}
          key={eventContext.state.messaging.activeRoom}
          source="selector"
          viewer={eventContext.state.event.manager ? "runner" : "rider"}
        />
      </Box>
      <Box className="box-default" sx={{ pt: configEntzy.APP_SPACING_MD }}>
        <Typography variant="subtitle1">
          <em>
            <span>Available default rooms</span>
          </em>
        </Typography>
      </Box>
      <Box
        className="box-default"
        sx={{
          pt: configEntzy.APP_SPACING_MD,
        }}
      >
        {visibleRooms.map((key, index) => {
          const room = eventContext.state.messaging.rooms[key];
          return (
            <Box
              key={room.name}
              className="box-default"
              sx={{
                // width: 100 / visibleRooms.length + "%",
                borderRadius: configEntzy.BORDER_SIZE_XL,
                pb: configEntzy.APP_SPACING_SM,
                // pr: [visibleRooms.length - 1].includes(index)
                //   ? 0
                //   : configEntzy.APP_SPACING_SM,
              }}
            >
              <ActionBoxButton
                size="small"
                text={room.title}
                subtext={room.description}
                bgColor={
                  eventContext.state.messaging.activeRoom === room.name
                    ? "primary.main"
                    : "black"
                }
                color={
                  eventContext.state.messaging.activeRoom === room.name
                    ? "black"
                    : "white"
                }
                borderColor={
                  eventContext.state.messaging.activeRoom === room.name
                    ? "black"
                    : undefined
                }
                rounded={true}
                textNoCasing={true}
                // disableElevation={true}
                selected={eventContext.state.messaging.activeRoom === room.name}
                onClick={() => {
                  eventContext.setMessageRoom(room.name);
                }}
              />
            </Box>
          );
        })}
      </Box>
      <Box
        className="box-default"
        hidden={eventContext.state.messaging.activeRoom.includes("desk")}
      >
        <Box className="box-default" sx={{ pt: configEntzy.APP_SPACING_MD }}>
          <Typography variant="subtitle1">
            <em>
              <span>Available side rooms</span>
            </em>
          </Typography>
        </Box>
        <Box className="box-default" sx={{ pt: configEntzy.APP_SPACING_MD }}>
          <ActionMessagingSelectorDates {...props} />
        </Box>
      </Box>
    </Box>
  );
}

export default ActionMessagingSelector;
